import * as React from "react";

export default function LicenseNameCell(props) {
	
	const { dataItem } = props;
	
  	return (
    	<td role="gridcell" aria-label={dataItem.product} tabIndex={0}>
			{dataItem.product}
		</td>
  	);
}